import React from 'react'
import PropTypes from 'prop-types'

import FormikFieldWrapper from '../FormikFieldWrapper'

const Field = ({name, label, children, ...props}) => {
  return (
    <FormikFieldWrapper label={label} name={name} {...props}>
      {children}
    </FormikFieldWrapper>
  )
}

Field.defaultProps = {
  type: 'text',
  icon: null,
  children: null,
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
}

export default Field
